import styled from '@emotion/styled'

import { BRAND_COLOR } from '@/constants/colors'

const COMPLETED_BG_COLOR = '#f5f5f6'

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px 8px 12px;
  background-color: ${BRAND_COLOR};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
`

export const ButtonText = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: white;
`

export const CompletedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  min-height: 32px;
  max-height: 60px;
  padding: 0;
  background-color: ${COMPLETED_BG_COLOR};
  border: none;
  border-radius: 10px;
  cursor: default;
  flex-shrink: 0;
`

export const CheckIcon = styled.img`
  width: 40px;
  height: 40px;
`
